
# Wraps the drawing toolbar up so some default actions
# can be handled more nicely

class exports.DrawToolbar extends L.Class
    constructor: () ->
        DrawToolbar.include(L.Mixin.Events)
        @drawMode       = ko.observable 'add'
        @currentTool    = ko.observable()

        @dontReenableDraw = false
        # Most recently clicked button (the currently active tool, usually)
        @lastClicked    = ko.observable()

        # Previously clicked button (which tool was active before the current, usually)
        @prevClicked    = ko.observable()
        @orig_options   = @initShapeDefaults()
        @drawnOptions   = @orig_options.shape

        @drawControlOptions =
            draw:
                polygon:
                    allowIntersection: false
                    shapeOptions: @orig_options.shape
                rectangle:
                    shapeOptions: @orig_options.shape
                circle:
                    shapeOptions: @orig_options.shape
                    units: 'english'


        @events         = new L.MassEvents()


    # Events:
    # - select:no-poly (Select button, nothing is being edited)
    # - select:poly-selected (A polygon has been clicked, now we're editing)
    #
    # - draw:poly-sub (Drawing mode, subtractive polygon)
    # - draw:poly-add (Drawing mode, additive polygon)
    # - draw:rect-sub (Drawing mode, subtractive rectangle)
    # - draw:rect-add (Drawing mode, additive rectangle)
    # - draw:circle-sub (Drawing Mode, subtractive circle)
    # - draw:circle-add (Drawing mode, additive circle)
    #
    # - delete:delete (Delete mode)


    # Initializes the draw toolbar. This includes setting up observables
    # and the @drawnItems container as well as initializing the actual
    # toolbar that is displayed on the map (L.Control.MfDraw).
    #
    # We also set up all the default/primary event handling for the control toolbar.
    # Some of this could probably be moved into L.Control.MfDraw so it is more of
    # a proper standalone control, but for now it makes sense to export the
    # functionality so it's easier to hack in support for Zone drawing later.
    #
    init: () ->

        # Initialize the draw control and pass it the FeatureGroup of editable layers
        @drawControl = new L.Control.MfDraw @drawControlOptions

        if not @drawnItems?
            @initDrawnItems()

        # add the control to the map
        App.map.addControl(@drawControl)

        @initListeners()



    initDrawnItems: () ->
        @drawnItems = new L.FeatureGroup()
        App.map.addLayer @drawnItems

        @undoStack  = new L.GeomUndoStack(@drawnItems)


    # Initializes primary listeners. These include handling the toggling of buttons/
    # disabling of the previous button's tool as well as more complex behaviors like
    # spawning L.Draw handlers when draw buttons are pressed. If a button is misbehaving,
    # it's most likely because something is borky here.
    initListeners: () ->
        self = this

        # tie in the undo stack.
        # When any of the below events are triggered,
        # the current state of @drawnItems is pushed to the undo stack
        @events.on [
                [this, ['delete:pre-delete', 'pre-add-feature']]
                [App.map, ['draw:point-begin-remove', 'draw:point-begin-edit']]
            ], @undoStack.push

        # Wire up union/difference handling when a new shape is drawn
        App.map.on 'draw:created', @handleDrawComplete

        # AAAALLLL the other things
        @drawControl.addCallback '*', @_anyButtonPressed
        @drawControl.addCallback 'draw-poly-sub,draw-rect-sub,draw-circle-sub', @_subtractiveButtonPressed
        @drawControl.addCallback 'draw-poly-add,draw-rect-add,draw-circle-add', @_additiveButtonPressed
        @drawControl.addCallback 'draw-poly-add,draw-poly-sub', @_drawPolygon
        @drawControl.addCallback 'draw-rect-add,draw-rect-sub', @_drawRectangle
        @drawControl.addCallback 'draw-circle-add,draw-circle-sub', @_drawCircle
        @drawControl.addCallback 'draw-undo', @_undoPressed
        @drawControl.addCallback 'draw-select', @_selectPressed
        @drawControl.addCallback 'draw-delete', @_deletePressed



    # Handles default behavior when any button is pressed
    _anyButtonPressed: (e, name) =>
        # handles cancelling existing edits
        if @currentTool()? and @currentTool().disable?
            @currentTool().disable()

        if name isnt 'draw-undo'
            @undoStack.clearInvalidGeometryFromStack()


        @prevClicked @lastClicked()
        @lastClicked name



    # Handles initializing a polygon drawing tool
    _drawPolygon: () =>
        self = this
        handler = new L.Draw.Polygon App.map, @drawControl.options.draw.polygon
        @currentTool({
            h: handler
            killed: false
            disable: () ->
                if @killed
                    return

                @killed = true
                if @h._poly?.getLatLngs?().length > 2
                    self.dontReenableDraw = true
                    @h._markers[0].fire('click')
                    self.dontReenableDraw = false
                else
                    @h.disable()

        })
        handler.enable()


    # Handles initializing a rectangle drawing tool
    _drawRectangle: () =>
        @currentTool( new L.Draw.Rectangle App.map, @drawControl.options.draw.rectangle )
        @currentTool().enable()


    # Handle initializing a circle drawing tool
    _drawCircle: () =>
        @currentTool( new L.Draw.BetterCircle App.map, @drawControl.options.draw.circle)
        @currentTool().enable()


    # Handle calling the undo stack and reselecting the shape if we were previously editing
    _undoPressed: () =>
        @undoStack.undo()
        if @prevClicked() is 'draw-select' and @drawnItems.getLayers().length is 1
            # Handle selection
            @drawControl.getButton('draw-select').trigger 'click'
            @_polySelected { layer: @drawnItems.getLayers()[0] }



    # Handles adding edit handles when you've selected
    # the 'select' tool
    _selectPressed: () =>
        self = this
        @drawnItems.on 'click', @_polySelected
        @fire 'select:no-poly'

        # This is kiind of hacky.. if the user clicks off
        # the tool without doing anything, we have to clean up
        @currentTool {
            h: null
            disable: () ->
                if @h? and @h.disable?
                    @h.disable()
                self.drawnItems.off 'click', @_polySelected
        }


    _deletePressed: () =>
        # if there's nothing we can delete, then just abort.
        if @drawnItems.getLayers().length is 0
            @drawControl.deselectBtn 'draw-delete'
            return

        cb = (e) =>
            @fire 'delete:pre-delete'
            @drawnItems.removeLayer e.layer
            @fire 'delete:layer-deleted', e.layer
            @currentTool().disable()
            @drawControl.deselectBtn 'draw-delete'



        tooltip = new L.Tooltip(App.map)
        tooltip.updateContent { text: 'Click on an area to delete it' }

        mm = (e) =>
            tooltip.updatePosition e.latlng
        App.map.on 'mousemove', mm

        @drawnItems.on 'click', cb
        @fire 'delete:delete'

        # again, a bit of a hack. If the user clicks off
        # the tool without doing anything, we have to clean stuff up
        @currentTool {
            disable: () =>
                @drawnItems.off 'click', cb
                @fire 'inactive'
                App.map.off 'mousemove', mm
                tooltip.dispose()
                @currentTool null
        }



    _polySelected: (e) =>
        handler = new L.Edit.PolyWithHoles(e.layer)
        handler.enable()
        @fire 'select:poly-selected'

        # Disable the previous selection
        if @currentTool().h? and @currentTool().h.disable?
            @currentTool().h.disable()

        #@currentTool#().disable()
        @currentTool().h = handler

        # This is a bit weird. We flag the featuregroup as invalid
        # So that next time we push to the stack, the state will be
        # flagged correctly. The reason we set it here instead of at
        # push time is because the state pushed to the stack isn't the *current*
        # feature state, it's the state just before we have altered the system;
        handler.on 'geometry-invalid', () =>
            @drawnItems.isInvalid = true

        handler.on 'geometry-valid', () =>
            @drawnItems.isInvalid = false



    # Little helper for getting the original default shape parameters for L.Draw handlers
    initShapeDefaults: () ->
        shapeOpts = {
            fillColor: '#00FF00'
            color: '#00FF00'
            opacity: 0.75
            weight: 2
            fillOpacity: 0.2
        }

        editOpts = $.extend shapeOpts, {
            fillOpacity: 0.1
            guidelineDistance: 20
        }

        return { shape: shapeOpts, edit: editOpts }


    # Convert geometries to JSTS (if they need it)
    # and then combine them with the specified operation
    _combineGeometry: (oldgeom, newgeom, operation) ->

        newGeom = L.GeoUtil.readToJSTS newgeom
        oldGeom = L.GeoUtil.readToJSTS oldgeom


        # Handle geometry vs feature group
        if newGeom.geometry?
            newGeom = newGeom.geometry

        # Handle adding / subtracting
        if not oldGeom?
            geom = newGeom
        else
            geom = oldGeom[operation] newGeom

        return geom


    # Handles what happens when you finish drawing a shape.
    # This is kind of compleximicated because leaflet itself
    # has no built in geometry manipulation functions (hmmm...)
    #
    # We convert the newly drawn object and @drawnItems into
    # jsts geometries, then depending on the @drawMode, we either
    # union or difference the new geometry against @drawnItems
    handleDrawComplete: (e) =>
        self    = this
        type    = e.layerType
        layer   = e.layer


        # unselect the previous button
        #if @lastClicked()?
        #    @drawControl.deselectBtn @lastClicked()


        if not @drawnItems?
            @initDrawnItems()


        if type is 'circle'
            # Convert the circle to a polygon representation so we can geoJSON it
            layer = new L.PolyCircle(layer.getLatLng(), layer.getRadius(), { nodes: 20 })
            layer = layer.getPoly()


        if @drawMode() is 'add'
            operation = 'union'
        else
            operation = 'difference'


        geom    = L.GeoUtil.combine @drawnItems, layer, operation
        out     = @_finalizeGeometry geom

        @fire 'pre-add-feature'

        @drawnItems.clearLayers()
        L.GeoUtil.unnestAdd @drawnItems, out
        @_setStyles()

        @fire 'post-add-feature'
        #@fire 'inactive'
        #
        if not @dontReenableDraw
            @drawControl.handleClick @lastClicked()


    # Sets styles for the whole drawnItems featuregroup
    _setStyles: (style) ->
        if not style?
            style = @drawnOptions

        @drawnItems.eachLayer (l) ->
            if l.setStyle?
                l.setStyle style


    _finalizeGeometry: (geom) =>
        return L.GeoUtil.readFromJSTS(geom, @drawnOptions)


    # Returns a list of drawn geometries as an array
    getAreas: (pusharray = [], start) ->
        if not start?
            start = @drawnItems #new L.GeoJSON(@drawnItems.toGeoJSON())

        start.eachLayer (layer) =>
            if layer instanceof L.FeatureGroup
                @getAreas pusharray, layer
            else
                pusharray.push layer

        return pusharray


    disableCurrent: () =>
        @currentTool()?.disable?()
        @currentTool(null)



    activate: (name) =>
        btn = @drawControl.getButton(name)

        if btn?
            @drawControl.handleClick name


    # Cleans up the L.Control.MfDraw, disables any active tools,
    # and removes event listeners. Also removes the @drawnItems
    # feature group from the map
    destroy: () ->
        App.map.removeControl @drawControl
        if @currentTool()? and @currentTool().disable?
            @currentTool().disable()

        App.map.off 'draw:created', @handleDrawComplete

        if @drawnItems?
            App.map.removeLayer @drawnItems
